import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { ImageQualityExamples, TransBold } from "./ImageQualityExamples";
import {
  InstructionDialogTitle,
  InstructionSection,
  InstructionSectionTitle,
} from "./PlantProfileInstructionsDialog";
import { useTranslation } from "react-i18next";
import InstructionsIcon from "@mui/icons-material/TipsAndUpdates";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import React, { FC, useState } from "react";
import WarningIcon from "@mui/icons-material/WarningAmber";
import XIcon from "@mui/icons-material/Close";

export const CategoryTemplateInstructionsDialog: FC = () => {
  const { t } = useTranslation();
  const muiTheme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        color="inherit"
        startIcon={<InstructionsIcon />}
        aria-label={t(
          "components.categoryCollectionProfile.instructions.trigger"
        )}
        onClick={() => setOpen(true)}
      >
        <span className="hidden md:block">
          {t("components.categoryCollectionProfile.instructions.trigger")}
        </span>
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <DialogTitle className="flex justify-between items-baseline">
          <InstructionDialogTitle>
            {t("components.categoryTemplates.instructions.dialogTitle")}
          </InstructionDialogTitle>
          <IconButton
            aria-label={t("utils.actions.close")}
            onClick={() => setOpen(false)}
          >
            <XIcon fontSize="large" />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <InstructionSection className="mt-2 mb-4">
            <Typography component="p" className="mt-0 mb-3">
              {t("components.categoryTemplates.instructions.whatItIs")}
            </Typography>
            <Alert
              severity="warning"
              className="rounded-md"
              icon={<WarningIcon fontSize="small" />}
            >
              {t("components.categoryTemplates.instructions.noAutoUpdate")}
            </Alert>
          </InstructionSection>

          <InstructionSection className="mt-2 mb-4">
            <InstructionSectionTitle>
              {t(
                "components.categoryCollectionProfile.instructions.titles.quality"
              )}
            </InstructionSectionTitle>

            <Alert
              severity="info"
              className="italic rounded-md"
              style={{
                backgroundColor: muiTheme.palette.info.main,
                color: muiTheme.palette.info.contrastText,
              }}
              icon={
                <LightbulbIcon
                  fontSize="small"
                  style={{
                    color: muiTheme.palette.info.contrastText,
                  }}
                />
              }
            >
              {t("components.categoryCollectionProfile.instructions.callout")}
            </Alert>

            <ol className="list-decimal ml-2 space-y-2">
              <li>
                <TransBold i18nKey="components.categoryTemplates.instructions.imageCount" />
              </li>
              <li>
                <TransBold i18nKey="components.categoryCollectionProfile.instructions.confidence" />
              </li>
            </ol>

            <Typography
              component="p"
              className="mt-2 mb-0 border-solid border-carbon-orange p-1"
            >
              <TransBold i18nKey="components.categoryCollectionProfile.instructions.implementation" />
            </Typography>
          </InstructionSection>

          <ImageQualityExamples />
        </DialogContent>
      </Dialog>
    </>
  );
};
